import { baseUrl } from "../Api/Api";
import { Box, Collapse, Grid, Hidden, Typography } from "@material-ui/core";
import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faFacebookMessenger,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronRight } from "@material-ui/icons";
import axios from "axios";

const items = [
  {
    title: "Doučování vysoká škola",
    items: [
      { url: "/kategorie/ucetnictvi-i", title: "Účetnictví I." },
      { url: "/kategorie/ucetnictvi-ii", title: "Účetnictví II." },
      { url: "/kategorie/mikroekonomie-i", title: "Mikroekonomie I." },
      { url: "/kategorie/mikroekonomie-ii", title: "Manažerské účetnictví I." },
      {
        url: "/kategorie/manazerske-ucetnictvi-ii",
        title: "Manažerské účetnictví II.",
      },
      { url: "/kategorie/makroekonomie-ii", title: "Makroekonomie II." },
      { url: "/kategorie/ifrs", title: "Účetnictví IFRS" },
      { url: "/kategorie/statistika", title: "Statistika" },
      { url: "/kategorie/matematika", title: "Matematika" },
      { url: "/kategorie/ekonomie-i", title: "Ekonomie I." },
      { url: "/kategorie/ekonomie-ii", title: "Ekonomie II." },
      {
        url: "/kategorie/mezinarodni-ekonomie-i",
        title: "Mezinárodní ekonomie I.",
      },
      {
        url: "/kategorie/mezinarodni-ekonomie-ii",
        title: "Mezinárodní ekonomie II.",
      },
      { url: "/kategorie/ocenovani-podniku-i", title: "Oceňování podniku I." },
      {
        url: "/kategorie/ocenovani-podniku-ii",
        title: "Oceňování podniku II.",
      },
      { url: "/kategorie/finance-podniku", title: "Finance podniku" },
      { url: "/kategorie/financni-analyza", title: "Finanční analýza" },
      { url: "/kategorie/manazerska-ekonomika", title: "Manažerská ekonomika" },
      {
        url: "/kategorie/ucetnictvi-statni-spravy",
        title: "Účetnictví státní správy",
      },
    ],
  },
  {
    title: "Sbírky příkladů",
    items: [
      { url: "", title: "Accounting'n'shit 1" },
      { url: "", title: "Accounting'n'shit 2.08" },
      { url: "", title: "Accounting'n'shit 2" },
      { url: "", title: "Mikro'n'shit 2" },
      { url: "", title: "1FU202 Záverečné testy (ZADÁNÍ)" },
      { url: "", title: "1FU202 Cenné papíry by Fífa (ZADÁNÍ)" },
      { url: "", title: "1FU202 DM by Fífa (ZADÁNÍ)" },
      { url: "", title: "Manažerko is not dead by Fífa" },
      { url: "", title: "Manažerko'n'shit" },
    ],
  },
  {
    title: "Doučování střední škola",
    items: [
      { url: "/kategorie/mocniny-a-odmocniny", title: "Mocniny a odmocniny" },
      { url: "/kategorie/vyrazy", title: "Výrazy" },
      { url: "/kategorie/funkce", title: "Funkce" },
      {
        url: "/kategorie/rovnice-a-jejich-soustavy",
        title: "Rovnice a jejich soustavy",
      },
      {
        url: "/kategorie/nerovnice-a-jejich-soustavy",
        title: "Nerovnice a jejich soustavy",
      },
      { url: "/kategorie/planimetrie", title: "Planimetrie" },
      { url: "/kategorie/analyticka-geometrie", title: "Analytická geometrie" },
    ],
  },
  {
    title: "O nalejvárnách",
    items: [
      { url: "/o-fifovi", title: "O Fífovi" },
      { url: "/recenze", title: "Recenze" },
      { url: "/faq", title: "FAQ" },
      { url: "/doporuc-a-ziskej", title: "Doporuč a získej" },
      { url: baseUrl + "/files/obchodni-podminky", title: "Obchodní podmínky" },
    ],
  },
];

const useStyles = makeStyles((theme) => {
  return {
    icons: {
      display: "flex",
      "& div": {
        marginLeft: 16,
        color: "#fff",
        fontSize: 33,
      },
    },
  };
});

const sortFn = (a, b) => {
  let aP, bP;
  aP = a.position;
  bP = b.position;
  if (aP === bP) return 0;
  if (aP < bP) return -1;
  if (aP > bP) return 1;
  return 0;
};

const LayoutFooter = () => {
  const classes = useStyles();

  const [opened, setOpened] = useState("");

  const [courses, setCourses] = React.useState([]);

  React.useEffect(() => {
    const homepageUrl = baseUrl + "/homepage";
    const homepageRequest = axios.get(homepageUrl);
    axios
      .all([homepageRequest])
      .then(
        axios.spread((...responses) => {
          setCourses(responses[0].data.courses);
        })
      )
      .catch((errors) => {});
  }, []);

  return (
    <>
      <Box
        style={{
          backgroundColor: "#797979",
          paddingTop: 8,
          paddingBottom: 8,
          marginTop: 92,
          marginBottom: 16,
        }}
      >
        <Container style={{ display: "flex" }}>
          <Box style={{ flexGrow: 1 }} />
          <Box className={classes.icons}>
            <Box>
              <a
                href={"https://www.instagram.com/videonalejvarny_prg/"}
                target={"_blank"}
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </Box>
            <Box>
              <a
                href={"https://www.youtube.com/@VIDEONALEJVARNY"}
                target={"_blank"}
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </Box>
            <Box>
              <a
                href={"https://m.me/accountingfifa"}
                target={"_blank"}
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookMessenger} />
              </a>
            </Box>
            <Box>
              <a
                href={"https://www.facebook.com/accountingfifa/reviews"}
                target={"_blank"}
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </Box>
          </Box>
        </Container>
      </Box>
      <Container style={{ paddingBottom: 32, paddingTop: 32 }}>
        <Hidden smDown={true}>
          <Grid container spacing={2}>
            {items.map((i) => {
              return (
                <Grid key={i.title} xl={3} lg={3} md={3} sm={12} xs={12}>
                  <Typography
                    variant={"h1"}
                    style={{ fontSize: 28, fontWeight: 700, marginBottom: 16 }}
                  >
                    {i.title}
                  </Typography>

                  {i.title === "Sbírky příkladů" && (
                    <>
                      {courses
                        .filter((course) =>
                          ["collectionOfExamples"].includes(
                            course.courseType.code
                          )
                        )
                        .sort(sortFn)
                        .map((c) => {
                          return (
                            <Box
                              component={"a"}
                              href={"/sbirky-prikladu/" + c.slug}
                              style={{ display: "block" }}
                            >
                              {c.title}
                            </Box>
                          );
                        })}
                    </>
                  )}

                  {i.title !== "Sbírky příkladů" &&
                    i.items.map((j) => {
                      return (
                        <Box
                          component={"a"}
                          href={j.url}
                          style={{ display: "block" }}
                        >
                          {j.title}
                        </Box>
                      );
                    })}
                </Grid>
              );
            })}
          </Grid>
        </Hidden>
        <Hidden mdUp={true}>
          {items.map((i) => {
            return (
              <Box key={i.title}>
                <Box
                  style={{
                    display: "flex",
                    marginTop: 8,
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant={"h6"}
                    style={{ flexGrow: 1 }}
                    onClick={() => {
                      setOpened((prev) => {
                        return prev === i.title ? "" : i.title;
                      });
                    }}
                  >
                    {i.title}
                  </Typography>
                  <ChevronRight />
                </Box>
                <Collapse in={opened === i.title}>
                  <Box style={{ paddingBottom: 16 }}>
                    {i.items.map((j) => {
                      return (
                        <Box
                          component={"a"}
                          href={j.url}
                          style={{ display: "block" }}
                        >
                          {j.title}
                        </Box>
                      );
                    })}
                  </Box>
                </Collapse>
              </Box>
            );
          })}
        </Hidden>
      </Container>
    </>
  );
};

export default LayoutFooter;

// <a href={baseUrl + "/files/obchodni-podminky"}>Obchodní podmínky</a>
// <a
//     style={{marginLeft: 16}}
//     href={baseUrl + "/files/zasady-ochrany-osobnich-udaju_VN.pdf"}
// >
//     Zásady ochrany osobních údajů
// </a>
